export default __webpack_public_path__ + "static/media/coffees.0e01ec0e.png";